module.exports = __webpack_public_path__ + "files/320911a0ad5e55f8ec5d7977f1782174.png";